export default {
    install(Vue, options) {
        Vue.prototype.$toProjectDetail = function (workId) {
            this.$router.push({
                path: `/community/projectDetail?workId=${workId}`,
            });
        }
        Vue.prototype.$toUserDetail = function (userId) {
            this.$router.push({
                path: `/community/friends?userId=${userId}`,
            });
        }
        Vue.prototype.$toGoodDetail = function (actionId) {
            this.$router.push({
                path: `/courseShop/goodsDetail?actId=${actionId}`,
            });
        }
        Vue.prototype.$getMobileLink = function (workId) {
            return window.location.protocol + "//" + window.location.host +
                "/scratch3/scratch-mobile.html?workId=" + workId

        }
    }
}